import { ReactNode } from 'react';
import { CenteredSpinner } from '~/commonComponents/CenteredSpinner';
import { useIsBestInDentalVisible } from '~/domain/BestInDental';
import { useViewedOfficeScope } from '~/hooks/useViewedOfficeScope';
import { getViewedOfficeId } from '~/utils/viewedOfficeScope';
import { NotAllowedGuard } from './NotAllowedGuard';

interface IBestInDentalGateProps {
  /** The location the page is for; omitted for the selected office. */
  officeId?: string;
  children: ReactNode;
}

const BestInDentalGate = ({ officeId, children }: IBestInDentalGateProps) => {
  const { visible, isLoading, isError } = useIsBestInDentalVisible(officeId);

  if (isLoading) return <CenteredSpinner />;

  return (
    <NotAllowedGuard customCondition={!visible && !isError} notAllowedReason="best-in-dental">
      {children}
    </NotAllowedGuard>
  );
};

/**
 * The Best in Dental routes' gate, asked for the office the page is for: the
 * location a Manage row opened it for (`?officeId=`), so a member location gets
 * in while a non-member parent is selected (GOTU-19472), else the selected office.
 */
export const BestInDentalRoute = ({ children }: { children: ReactNode }) => {
  const scope = useViewedOfficeScope();

  if (!scope) return <CenteredSpinner />;

  return <BestInDentalGate officeId={getViewedOfficeId(scope)}>{children}</BestInDentalGate>;
};
